// Fetch + convert sprite library dari /public/assets/sprites/.
// MVP F-05: 6 sprite (kiko, apel, rock, ground, awan, bintang) + 1 sound (beep).
// V1.1: asset library 60 sprite dari Doc 09 §11.

const SPRITE_LIBRARY = [
  { key: 'kiko', url: '/assets/sprites/kiko.svg' },
  { key: 'apel', url: '/assets/sprites/apel.svg' },
  { key: 'rock', url: '/assets/sprites/rock.svg' },
  { key: 'ground', url: '/assets/sprites/ground.svg' },
  { key: 'awan', url: '/assets/sprites/awan.svg' },
  { key: 'bintang', url: '/assets/sprites/bintang.svg' },
]

const SOUND_URL = '/assets/sounds/beep.wav'

const cache = new Map()

async function fetchAsDataUrl(url) {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status}`)
  const blob = await res.blob()
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(new Error(`FileReader failed for ${url}`))
    reader.readAsDataURL(blob)
  })
}

async function svgToPngDataUrl(svgDataUrl, size = 128) {
  if (typeof OffscreenCanvas === 'undefined') {
    return svgDataUrl
  }
  try {
    const img = new Image()
    img.src = svgDataUrl
    await img.decode()
    const canvas = new OffscreenCanvas(size, size)
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, size, size)
    const blob = await canvas.convertToBlob({ type: 'image/png' })
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = () => reject(new Error('PNG convert failed'))
      reader.readAsDataURL(blob)
    })
  } catch (err) {
    console.warn('[assets] SVG→PNG convert failed, using SVG raw', err)
    return svgDataUrl
  }
}

export async function loadPlaceholderAssets() {
  // Backward-compat: same name, but now loads full library.
  if (cache.size >= SPRITE_LIBRARY.length + 1) {
    return Array.from(cache.values())
  }

  const spriteFetches = SPRITE_LIBRARY.map(async (sprite) => {
    if (cache.has(sprite.key)) return cache.get(sprite.key)
    const svgDataUrl = await fetchAsDataUrl(sprite.url)
    const pngDataUrl = await svgToPngDataUrl(svgDataUrl, 128)
    const entry = { key: sprite.key, dataUrl: pngDataUrl }
    cache.set(sprite.key, entry)
    return entry
  })

  const soundFetch = (async () => {
    if (cache.has('beep')) return cache.get('beep')
    const dataUrl = await fetchAsDataUrl(SOUND_URL)
    const entry = { key: 'beep', dataUrl }
    cache.set('beep', entry)
    return entry
  })()

  return Promise.all([...spriteFetches, soundFetch])
}

export function getSpriteLibraryKeys() {
  return SPRITE_LIBRARY.map((s) => s.key)
}
